<template>
  <div class="security-picker">
    <!-- 输入框 -->
    <van-field
      required
      readonly
      error-message=" "
      :value="fieldValue"
      :label="label"
      :name="name"
      :placeholder="'请选择' + label"
      :rules="[{ required: true, message: '请选择' + label }]"
      @click="clickField"
      input-align="right"
    ></van-field>

    <!-- 弹出层 -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      @open="openSelector()"
      @close="closeSelector()"
    >
      <div class="security-picker-selector">
        <!-- 按钮 -->
        <div class="selector-header">
          <div @click="isShowPopup = false">取消</div>
          <div @click="clickComfirm">确定</div>
        </div>
        <!-- 搜索  -->
        <div class="selector-search">
          <van-cell-group>
            <van-field
              v-model="searchValue"
              placeholder="输入搜索"
              input-align="center"
              clearable
              @input="inputSelectorSearch"
            />
          </van-cell-group>
        </div>
        <!-- 列表 -->
        <div class="selector-content">
          <div
            :class="[
              'selector-content-item',
              {
                active:
                  item.selectorItemId ===
                  (selectorActive.selectorItemId
                    ? selectorActive.selectorItemId
                    : ''),
              },
            ]"
            v-for="(item, index) in selectorSearchList"
            :key="index"
            @click="clickSelectorItem(item)"
          >
            {{ item.selectorItemLabel }}
          </div>
        </div>
        <!-- 分页 -->
        <van-pagination
          v-model="pageNumber"
          :total-items="total"
          :items-per-page="pageSize"
          v-if="name === 'car'"
          @change="changePaginationPage"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowPopup: false, // 弹出层
      fieldValue: "", // 输入框
      searchValue: "", // 搜索框
      selectorList: [], // 选择器list
      selectorSearchList: [], // 选择器list
      selectorActive: {}, // 选择器选中
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      carSearchTimeId: null, // 车辆搜索定时器
    };
  },
  methods: {
    // 弹出层关闭时
    closeSelector() {
      this.selectorActive = {};
    },
    // 弹出层打开时
    openSelector() {
      if (this.name === "line") {
        if (!this.parentSelectorActive.GID) return;
        this.selectorActive = this.parentSelectorActive;
      }
    },
    // 输入框事件
    inputSelectorSearch() {
      if (this.name !== "car") {
        this.selectorSearchList = this.selectorList.filter((item) => {
          return item.selectorItemLabel.includes(this.searchValue);
        });
      } else if (this.name === "car") {
        if (this.carSearchTimeId !== null) {
          clearTimeout(this.carSearchTimeId);
        }
        this.carSearchTimeId = setTimeout(() => {
          this.handlerCarQuery();
        }, 1300);
      }
    },
    // 传父级
    handlerTransferParent() {
      this.$emit("comfirm", this.selectorActive, this.name);
    },
    // 清除旧数据
    handlerClearData() {
      this.fieldValue = "";
      this.selectorActive = {};
      this.handlerTransferParent();
    },
    // 分页页码改变时触发
    changePaginationPage() {
      this.handlerCarQuery();
    },
    // 车辆请求
    handlerCarQuery() {
      this.$http
        .post(this.$api.CompanyVehicleSimplifyQuery, {
          page: this.pageNumber,
          start: (this.pageNumber - 1) * this.pageSize,
          limit: this.pageSize,
          query: this.searchValue,
        })
        .then((res) => {
          this.total = res.total;
          this.handlerQueryData(res.data, "VehicleNo");
        });
    },
    // 点击选项
    clickSelectorItem(data) {
      this.selectorActive = data;
    },
    // 点击弹出层确定按钮
    clickComfirm() {
      this.fieldValue = this.selectorActive.selectorItemLabel;
      this.handlerTransferParent();
      this.isShowPopup = false;
    },
    // 处理请求返回数据
    handlerQueryData(data, type) {
      this.isShowPopup = true;
      let temp = data.map((item) => {
        return {
          ...item,
          selectorItemLabel: item[type],
          selectorItemId: item.GID,
        };
      });
      this.selectorSearchList = temp;
      this.selectorList = temp;
    },
    // 点击输入框
    clickField() {
      this.searchValue = "";
      this.pageNumber = 1;
      this.total = 0;
      // this.fieldValue = "";
      // this.selectorList = [];
      // this.selectorSearchList = [];
      // this.selectorActive = {};
      // this.handlerTransferParent();

      // 线路
      if (this.name === "line") {
        this.$http.post(this.$api.SecurityLine).then((res) => {
          this.handlerQueryData(res.data, "LineName");
        });
      }
      // 起点
      else if (this.name === "startNode") {
        if (!this.handlerHaveParam) return;
        this.$http
          .post(this.$api.getLineClassStartNode, {
            LineGID: this.pickerParam.LineGID,
          })
          .then((res) => {
            this.handlerQueryData(res.data, "NodeName");
          });
      }
      // 终点
      else if (this.name === "endNode") {
        if (!this.handlerHaveParam) return;
        this.$http
          .post(this.$api.getLineClassArrivalNode, {
            LineGID: this.pickerParam.LineGID,
          })
          .then((res) => {
            this.handlerQueryData(res.data, "NodeName");
          });
      }
      // 车辆
      else if (this.name === "car") {
        this.handlerCarQuery();
      }
    },
  },
  computed: {
    handlerHaveParam: function() {
      let flag = false;
      if (this.pickerParam.GID) {
        flag = true;
      } else {
        this.$toast("请选择线路");
      }
      return flag;
    },
  },
  props: {
    label: {
      type: [String],
    },
    name: {
      type: [String],
    },
    pickerParam: {
      type: [Object],
    },
    parentSelectorActive: {
      type: [Object],
    },
  },
};
</script>
<style lang="less" scoped>
.security-picker {
  border-bottom: 1px solid #dddddd85;

  /deep/.van-cell {
    font-size: 0.42rem;
    .van-cell__title,
    .van-cell__value {
      color: #000;
    }
  }
  .van-cell::after {
    border: none;
  }

  .security-picker-selector {
    height: 60vh;
    display: flex;
    flex-direction: column;
    .selector-header {
      display: flex;
      justify-content: space-between;
      font-size: 0.4rem;
      padding: 0.3rem 0.4rem;
      border-bottom: 1px solid #dddddd85;

      & > :nth-child(1) {
        color: #aaa;
      }
      & > :nth-child(2) {
        color: #4ea1e1;
      }
    }
    .selector-search {
      border-bottom: 1px solid #dddddd85;

      /deep/ .van-cell-group::after {
        border: none;
      }
      /deep/ .van-field__control {
        font-size: 0.42rem;
      }
    }
    .selector-content {
      flex: 1;
      padding: 0 0.5rem;
      overflow: auto;

      .selector-content-item {
        padding: 0.3rem 0.4rem;
        font-size: 0.42rem;
        border-bottom: 1px solid #eeeeee81;
      }
      .active {
        background-color: #ddd;
      }
    }
  }
}
</style>
